import Shepherd from 'shepherd.js'
import store from '../store'

export function createWt() {
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            classes: 'c-walkthrough',
            modalOverlayOpeningPadding: 15,
            modalOverlayOpeningRadius: 5,
            popperOptions: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 24]
                        }
                    }
                ]
            },
            scrollTo: true,
            cancelIcon: {
                enabled: true
            }
        },
        useModalOverlay: true
    })

    return tour
}

export function addSteps(tour, stepsArr, filterSteps = []) {
    if (filterSteps.length) {
        stepsArr = stepsArr.filter(step => filterSteps.includes(step.id))
    }

    const buttonPrev = {
        text: 'Wstecz',
        classes: 'btn btn-outline-custom walkthrough-previous-step-btn',
        action: tour.back
    }
    const buttonNext = {
        text: 'Dalej',
        classes: 'btn  btn-secondary walkthrough-next-step-btn',
        action: tour.next
    }
    let stepButtons = []

    let title = ''
    stepsArr.forEach((step, idx) => {
        if ('title' in step) title = step.title
        let nButtonPrev = buttonPrev
        let nButtonNext = buttonNext

        if ('actionPrev' in step) {
            nButtonPrev = Object.assign(
                { ...nButtonPrev },
                {
                    action() {
                        step.actionPrev()
                        setTimeout(() => {
                            tour.back()
                        }, 0)
                    }
                }
            )
        }
        if ('actionNext' in step) {
            nButtonNext = Object.assign(
                { ...nButtonNext },
                {
                    action() {
                        step.actionNext()
                        setTimeout(() => {
                            tour.next()
                        }, 0)
                    }
                }
            )
        }

        if (idx === 0) {
            stepButtons = [nButtonNext]
        } else if (idx === stepsArr.length - 1) {
            nButtonNext = Object.assign(
                { ...nButtonNext },
                {
                    text: 'Koniec',
                    action() {
                        store.dispatch('toggleModal', false)
                        tour.complete()
                    }
                }
            )
            stepButtons = [nButtonPrev, nButtonNext]
        } else {
            stepButtons = [nButtonPrev, nButtonNext]
        }

        tour.addStep({
            title,
            buttons: stepButtons,
            ...step
        })
    })
}
